module.exports = __webpack_public_path__ + "static/algorand-mantle-animatiom-16-9_algorand-home-356e25dfdef3aa493d769bc6946a9514.mp4";